// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of } from 'rxjs';

// --- HS Code
import { DemographicValueModel } from '../../../models';
import { AppService } from '../app.service';
import { DemographicsBaseService } from '../system/demographics-base.service';
import { UserDemographicsBaseService } from './user-demographics-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class UserDemographicsMockService extends UserDemographicsBaseService {
  constructor(
    appService: AppService,
    demographicService: DemographicsBaseService
  ) {
    super(appService, demographicService);
  }

  loadUserDemographicValues(): void {
    const userDemographicValues = [
      { id: 'v1', demographicId: '1', name: '1971', index: 1 },
      {
        id: 'v12',
        demographicId: '2',
        name: 'Mars, the Free Republic of',
        index: 3,
      },
      { id: 'v6', demographicId: '3', name: 'Male', index: 1 },
      { id: 'v18', demographicId: '4', name: 'Volunteer', index: 4 },
    ] as DemographicValueModel[];
    this._userDemographicValues$.next(userDemographicValues);
  }

  loadFromUserDetails(userDemographicValues: DemographicValueModel[]) {
    this._userDemographicValues$.next(userDemographicValues);
  }

  updateUserDemographics(
    userDemographicValues: DemographicValueModel[]
  ): Observable<boolean> {
    this._userDemographicValues$.next(userDemographicValues);
    return of(true);
  }

  updateUserDemographicsFromProfile(
    userDemographicValues: DemographicValueModel[]
  ): void {
    this._userDemographicValues$.next(userDemographicValues);
  }
}
